import React from 'react';
import './Button.css';

export default function Button({
  children,
  onClick,
  href,
  target = '_blank',
  rel = 'noopener noreferrer',
  className = '',
  type = 'button',
  size = 'large',
  fixedWidth = true,
  ...rest
}) {
  const classNames = [
    'button',
    fixedWidth ? 'btn-width-fixed' : 'btn-width-auto',
    `btn-size-${size}`,
    className,
  ].join(' ');

  const commonProps = { className: classNames, ...rest };

  if (href) {
    // External link
    return (
      <a href={href} target={target} rel={rel} {...commonProps}>
        {children}
      </a>
    );
  }

  // Default button
  return (
    <button onClick={onClick} type={type} {...commonProps}>
      {children}
    </button>
  );
}
